import React from 'react';
import AdminLayout from '../../../Components/CommonComponents/Layout/adminLayout';
import AdsContainer from '../../../Containers/AdminContainer/Ads';

const AdsScreen = () => {
  return <AdsContainer />;
};

export default AdsScreen;
